import { Pipe, PipeTransform } from '@angular/core';
import * as linkifyStr from 'linkifyjs/string';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {

  transform(str: string, type): string {
    const response = linkifyStr(str, type, {target: '_system'});
    type = type>=10?1:type;
    if(type === 1){
      return str ? response.html : str;
    }else{
      return str ? response.link : str;
    }
  }

}
